import _ from 'lodash';
import React, { Component } from 'react';

import Select from 'corp/components/UI/Select';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';
import { IContractJson } from '@scale/shared/types/contract';

interface SelectOption {
  label: string;
  value: string;
}

interface IFindContractsResponse {
  contracts: Partial<IContractJson>[];
}

interface ISelectContractProps {
  multi?: boolean;
  value?: SelectOption | SelectOption[];
  onChange?: ((value?: SelectOption) => void) | ((value?: SelectOption[]) => void);
  placeholder?: string;
  disabled?: boolean;
}

export default class SelectContract extends Component<ISelectContractProps> {
  static defaultProps = {
    placeholder: 'Select contract (search by SO#)',
  };

  private debounceTimer: NodeJS.Timeout | null = null;

  async fetchContracts(search: string) {
    if (!search) {
      return [];
    }

    try {
      const results: IFindContractsResponse = await apiFetch(null, `corp-api/contracts/find`, {
        query: Object.assign({}, _.pickBy({ search })),
      });

      results.contracts = _.sortBy(results.contracts, 'salesOrder');

      const options: SelectOption[] = results.contracts.map(contract => {
        return {
          label: `${contract.salesOrder}, version ${contract.contractVersion} (${contract._id})`,
          value: contract._id!,
        };
      });

      return { options };
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
      return [];
    }
  }

  debouncedFetch = (search: string): Promise<any> => {
    return new Promise(resolve => {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }

      this.debounceTimer = setTimeout(async () => {
        const result = await this.fetchContracts(search);
        resolve(result);
      }, 400);
    });
  };

  render() {
    return (
      <React.Fragment>
        <Select {...this.props} loadOptions={this.debouncedFetch} defaultMenuIsOpen />
      </React.Fragment>
    );
  }
}
